import { type Editor } from '@tiptap/react';

import { Icon } from '@flintmint/web-shared/components/icon';

import { useToaster } from '@flintmint/web-shared/hooks/use-toaster';

import { copyToClipboard } from '@/utils/helper-utils';
import { getEditorHTML } from '@/utils/editor-utils';

import styles from './copy-to-clipboard-btn.module.scss';

export const CopyToClipboardBtn = (props: CopyToClipboardBtnProps) => {
  const { editor } = props;

  const { showToastNotification } = useToaster();

  const handleCopy = async () => {
    try {
      if (editor.isEmpty) {
        return showToastNotification({
          type: 'warning',
          title: 'Nothing to copy',
          showCloseButton: false,
        });
      }

      await copyToClipboard({ content: getEditorHTML(editor), textContent: editor.getText() });

      showToastNotification({
        type: 'success',
        title: 'Copied to clipboard',
        showCloseButton: false,
      });
    } catch (error) {
      showToastNotification({
        type: 'error',
        title: 'Copy failed. Please try again',
        showCloseButton: false,
      });
    }
  };

  return (
    <button className={styles.copyToClipboard} onClick={handleCopy}>
      <Icon type="copy-01-bulk" multiColor className={styles.icon} size={18} />
      <span>Copy to Clipboard</span>
    </button>
  );
};

interface CopyToClipboardBtnProps {
  editor: Editor;
}
